
import Vue from 'vue'

const locales = {keys(){return []}}
global['____B85EBF2____'] = true;
delete global['____B85EBF2____'];
global.__uniConfig = {"easycom":{"^u-(.*)":"@/uview-ui/components/u-$1/u-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"preloadRule":{"pages/chat/index":{"network":"all","packages":["pagesA"]},"pages/resume/detail":{"network":"all","packages":["pagesA"]},"pagesA/chat/chat":{"network":"all","packages":["__APP__"]}},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"打听猫招聘","navigationBarBackgroundColor":"#fff","backgroundColor":"#F8F8F8"},"tabBar":{"color":"#909399","selectedColor":"#303133","borderStyle":"black","backgroundColor":"#ffffff","list":[{"pagePath":"pages/index/index","iconPath":"static/images/icons/home/home.png","selectedIconPath":"static/images/icons/home/home-active.png","text":"首页","redDot":false,"badge":""},{"pagePath":"pages/company/list","iconPath":"static/images/icons/home/company.png","selectedIconPath":"static/images/icons/home/company-active.png","text":"企业","redDot":false,"badge":""},{"pagePath":"pages/recruit/list","iconPath":"static/images/icons/home/job.png","selectedIconPath":"static/images/icons/home/job-active.png","text":"岗位","redDot":false,"badge":""},{"pagePath":"pages/chat/index","iconPath":"static/images/icons/home/chat.png","selectedIconPath":"static/images/icons/home/chat-active.png","text":"聊天","redDot":false,"badge":""},{"pagePath":"pages/my/my","iconPath":"static/images/icons/home/my.png","selectedIconPath":"static/images/icons/home/my-active.png","text":"我的","redDot":false,"badge":""}]}};
global.__uniConfig.compilerVersion = '3.99';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__B85EBF2';
global.__uniConfig.appName = '打听猫招聘';
global.__uniConfig.appVersion = '1.5.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/app/"};
global.__uniConfig.publicPath = "/app/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"SJSBZ-GQ4LF-QQDJ6-NBL77-VQ6W5-CEFI7"}}};
global.__uniConfig.qqMapKey = "SJSBZ-GQ4LF-QQDJ6-NBL77-VQ6W5-CEFI7";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-miniDump', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/index/miniDump"+'.vue')), 'pages-index-miniDump'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recruit-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/recruit/list"+'.vue')), 'pages-recruit-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-site', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/index/site"+'.vue')), 'pages-index-site'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-webview-webview', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/webview/webview"+'.vue')), 'pages-webview-webview'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-resume-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/resume/list"+'.vue')), 'pages-resume-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-chooseRole-chooseRole', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/login/chooseRole/chooseRole"+'.vue')), 'pages-login-chooseRole-chooseRole'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-resumeUser-resumeEnter', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/resumeUser/resumeEnter"+'.vue')), 'pages-resumeUser-resumeEnter'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-forgotPassword-resetPassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/login/forgotPassword/resetPassword"+'.vue')), 'pages-login-forgotPassword-resetPassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-forgotPassword-appealPassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/login/forgotPassword/appealPassword"+'.vue')), 'pages-login-forgotPassword-appealPassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-forgotPassword-codePassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/login/forgotPassword/codePassword"+'.vue')), 'pages-login-forgotPassword-codePassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-resumeUser-infoRegister', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/resumeUser/infoRegister"+'.vue')), 'pages-resumeUser-infoRegister'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-resume-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/resume/detail"+'.vue')), 'pages-resume-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-company-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/company/list"+'.vue')), 'pages-company-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-my', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/my"+'.vue')), 'pages-my-my'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-company-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/company/detail"+'.vue')), 'pages-company-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResume', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResume"+'.vue')), 'pages-my-jobSeekers-myResume'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myCollection', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myCollection"+'.vue')), 'pages-my-jobSeekers-myCollection'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myPositionSubscribe', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myPositionSubscribe"+'.vue')), 'pages-my-jobSeekers-myPositionSubscribe'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-mySet-setAccount-bindWechat', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/mySet/setAccount/bindWechat"+'.vue')), 'pages-my-mySet-setAccount-bindWechat'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recruit-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/recruit/detail"+'.vue')), 'pages-recruit-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumePreview', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumePreview"+'.vue')), 'pages-my-jobSeekers-myResumePreview'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-myInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/myInfo"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-myInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-jobIntention', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/jobIntention"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-jobIntention'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-expectedBenefits', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/expectedBenefits"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-expectedBenefits'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-experience', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/experience"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-experience'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-selectSchool', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/selectSchool"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-selectSchool'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-workExperience', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/workExperience"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-workExperience'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-selfIntroduction', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/selfIntroduction"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-selfIntroduction'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-myHonor', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/myHonor"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-myHonor'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-myHonorCertificates', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/myHonorCertificates"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-myHonorCertificates'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-myTrainings', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/myTrainings"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-myTrainings'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-jobSeekers-myResumeDetail-resumeTalk', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/jobSeekers/myResumeDetail/resumeTalk"+'.vue')), 'pages-my-jobSeekers-myResumeDetail-resumeTalk'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-recruiter-companyInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/recruiter/companyInfo"+'.vue')), 'pages-my-recruiter-companyInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-recruiter-companyCertificationInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/recruiter/companyCertificationInfo"+'.vue')), 'pages-my-recruiter-companyCertificationInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-recruiter-resumeManage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/recruiter/resumeManage"+'.vue')), 'pages-my-recruiter-resumeManage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-recruiter-myInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/recruiter/myInfo"+'.vue')), 'pages-my-recruiter-myInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-search', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/index/search"+'.vue')), 'pages-index-search'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recruit-publicList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/recruit/publicList"+'.vue')), 'pages-recruit-publicList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recruit-pubilcDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/recruit/pubilcDetail"+'.vue')), 'pages-recruit-pubilcDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-company-searchCompany', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/company/searchCompany"+'.vue')), 'pages-company-searchCompany'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recruit-tabList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/recruit/tabList"+'.vue')), 'pages-recruit-tabList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-recruiter-registerCo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/recruiter/registerCo"+'.vue')), 'pages-my-recruiter-registerCo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chat-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/chat/index"+'.vue')), 'pages-chat-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-selectLogin', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/login/selectLogin"+'.vue')), 'pages-login-selectLogin'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-recruiter-getResume', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pages/my/recruiter/getResume"+'.vue')), 'pages-my-recruiter-getResume'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesA-chat-chat', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesA/chat/chat"+'.vue')), 'pagesA-chat-chat'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesA-chat-phrase', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesA/chat/phrase"+'.vue')), 'pagesA-chat-phrase'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesA-smartRobot-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesA/smartRobot/index"+'.vue')), 'pagesA-smartRobot-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesB-privacyAgreement-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesB/privacyAgreement/index"+'.vue')), 'pagesB-privacyAgreement-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesB-userAgreement-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesB/userAgreement/index"+'.vue')), 'pagesB-userAgreement-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesB-map-mapPage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesB/map/mapPage"+'.vue')), 'pagesB-map-mapPage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesB-recruit-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesB/recruit/list"+'.vue')), 'pagesB-recruit-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-setAccount-changePhone', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/mySet/setAccount/changePhone"+'.vue')), 'pagesMy-my-mySet-setAccount-changePhone'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-setAccount-changePassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/mySet/setAccount/changePassword"+'.vue')), 'pagesMy-my-mySet-setAccount-changePassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-setAccount-changeAccount', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/mySet/setAccount/changeAccount"+'.vue')), 'pagesMy-my-mySet-setAccount-changeAccount'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-setAccount-mySetAccount', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/mySet/setAccount/mySetAccount"+'.vue')), 'pagesMy-my-mySet-setAccount-mySetAccount'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-contactService', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/contactService"+'.vue')), 'pagesMy-my-contactService'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-myFeedback', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/myFeedback"+'.vue')), 'pagesMy-my-myFeedback'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-mySet', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/mySet/mySet"+'.vue')), 'pagesMy-my-mySet-mySet'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-undateVersion', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/mySet/undateVersion"+'.vue')), 'pagesMy-my-mySet-undateVersion'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-setNotice', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/mySet/setNotice"+'.vue')), 'pagesMy-my-mySet-setNotice'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-recruiter-myOrder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/recruiter/myOrder"+'.vue')), 'pagesMy-my-recruiter-myOrder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-recruiter-myPackage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/recruiter/myPackage"+'.vue')), 'pagesMy-my-recruiter-myPackage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-recruiter-companyAddress', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/recruiter/companyAddress"+'.vue')), 'pagesMy-my-recruiter-companyAddress'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-recruiter-companyAddressEdit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/recruiter/companyAddressEdit"+'.vue')), 'pagesMy-my-recruiter-companyAddressEdit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-recruiter-downResume', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/recruiter/downResume"+'.vue')), 'pagesMy-my-recruiter-downResume'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-recruiter-myResruit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/recruiter/myResruit"+'.vue')), 'pagesMy-my-recruiter-myResruit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-recruiter-resumePublish', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/recruiter/resumePublish"+'.vue')), 'pagesMy-my-recruiter-resumePublish'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-jobSeekers-myDeliver', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/jobSeekers/myDeliver"+'.vue')), 'pagesMy-my-jobSeekers-myDeliver'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-register-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/register/index"+'.vue')), 'pagesMy-register-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-myMembership', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/myMembership"+'.vue')), 'pagesMy-my-myMembership'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-attachment-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/attachment/index"+'.vue')), 'pagesMy-my-attachment-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-attachment-guide', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/JiDian/dtpzp_uniapp/pagesMy/my/attachment/guide"+'.vue')), 'pagesMy-my-attachment-guide'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"打听猫招聘","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:44
}
},
{
path: '/pages/index/miniDump',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-index-miniDump', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-miniDump',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/miniDump',
  windowTop:44
}
},
{
path: '/pages/recruit/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarTitleText":"全部工作","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#fff","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-recruit-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-recruit-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recruit/list',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:44
}
},
{
path: '/pages/index/site',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择城市","enablePullDownRefresh":false})
      },
      [
        createElement('pages-index-site', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-site',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/site',
  windowTop:44
}
},
{
path: '/pages/webview/webview',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-webview-webview', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-webview-webview',
  isNVue:false,maxWidth:0,
  pagePath:'pages/webview/webview',
  windowTop:44
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录打听猫","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:44
}
},
{
path: '/pages/resume/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"全部简历","enablePullDownRefresh":false})
      },
      [
        createElement('pages-resume-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-resume-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/resume/list',
  windowTop:44
}
},
{
path: '/pages/login/chooseRole/chooseRole',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择角色","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-chooseRole-chooseRole', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-chooseRole-chooseRole',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/chooseRole/chooseRole',
  windowTop:44
}
},
{
path: '/pages/resumeUser/resumeEnter',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#ffd203"})
      },
      [
        createElement('pages-resumeUser-resumeEnter', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-resumeUser-resumeEnter',
  isNVue:false,maxWidth:0,
  pagePath:'pages/resumeUser/resumeEnter',
  windowTop:44
}
},
{
path: '/pages/login/forgotPassword/resetPassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-forgotPassword-resetPassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-forgotPassword-resetPassword',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/forgotPassword/resetPassword',
  windowTop:44
}
},
{
path: '/pages/login/forgotPassword/appealPassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-forgotPassword-appealPassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-forgotPassword-appealPassword',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/forgotPassword/appealPassword',
  windowTop:44
}
},
{
path: '/pages/login/forgotPassword/codePassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-forgotPassword-codePassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-forgotPassword-codePassword',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/forgotPassword/codePassword',
  windowTop:44
}
},
{
path: '/pages/resumeUser/infoRegister',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"简历编辑","enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-resumeUser-infoRegister', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-resumeUser-infoRegister',
  isNVue:false,maxWidth:0,
  pagePath:'pages/resumeUser/infoRegister',
  windowTop:0
}
},
{
path: '/pages/resume/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-resume-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-resume-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/resume/detail',
  windowTop:0
}
},
{
path: '/pages/company/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"企业","enablePullDownRefresh":false})
      },
      [
        createElement('pages-company-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-company-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/company/list',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:44
}
},
{
path: '/pages/my/my',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:4
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人中心","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-my-my', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-my-my',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/my',
isQuit:true,
isTabBar:true,
tabBarIndex:4,
  windowTop:44
}
},
{
path: '/pages/company/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公司主页","navigationStyle":"custom","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-company-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-company-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/company/detail',
  windowTop:0
}
},
{
path: '/pages/my/jobSeekers/myResume',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的简历","enablePullDownRefresh":false,"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-jobSeekers-myResume', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResume',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResume',
  windowTop:0
}
},
{
path: '/pages/my/jobSeekers/myCollection',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"职位收藏","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myCollection', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myCollection',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myCollection',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myPositionSubscribe',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-jobSeekers-myPositionSubscribe', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myPositionSubscribe',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myPositionSubscribe',
  windowTop:0
}
},
{
path: '/pages/my/mySet/setAccount/bindWechat',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定微信","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-mySet-setAccount-bindWechat', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-mySet-setAccount-bindWechat',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/mySet/setAccount/bindWechat',
  windowTop:44
}
},
{
path: '/pages/recruit/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"招聘详情","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#fff","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-recruit-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-recruit-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recruit/detail',
  windowTop:0
}
},
{
path: '/pages/my/jobSeekers/myResumePreview',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"简历详情","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-my-jobSeekers-myResumePreview', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumePreview',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumePreview',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/myInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人信息","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-myInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-myInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/myInfo',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/jobIntention',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"求职意向","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-jobIntention', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-jobIntention',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/jobIntention',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/expectedBenefits',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"期望福利","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-expectedBenefits', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-expectedBenefits',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/expectedBenefits',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/experience',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"教育经历","enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-experience', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-experience',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/experience',
  windowTop:0
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/selectSchool',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"学校名称","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-selectSchool', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-selectSchool',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/selectSchool',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/workExperience',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工作经历","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-workExperience', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-workExperience',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/workExperience',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/selfIntroduction',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"自我介绍","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-selfIntroduction', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-selfIntroduction',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/selfIntroduction',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/myHonor',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"获得荣誉","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-myHonor', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-myHonor',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/myHonor',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/myHonorCertificates',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"荣誉证书","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-myHonorCertificates', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-myHonorCertificates',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/myHonorCertificates',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/myTrainings',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"培训经历","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-myTrainings', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-myTrainings',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/myTrainings',
  windowTop:44
}
},
{
path: '/pages/my/jobSeekers/myResumeDetail/resumeTalk',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-jobSeekers-myResumeDetail-resumeTalk', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-jobSeekers-myResumeDetail-resumeTalk',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/jobSeekers/myResumeDetail/resumeTalk',
  windowTop:44
}
},
{
path: '/pages/my/recruiter/companyInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"企业信息","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-recruiter-companyInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-recruiter-companyInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/recruiter/companyInfo',
  windowTop:44
}
},
{
path: '/pages/my/recruiter/companyCertificationInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"企业认证","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-recruiter-companyCertificationInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-recruiter-companyCertificationInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/recruiter/companyCertificationInfo',
  windowTop:44
}
},
{
path: '/pages/my/recruiter/resumeManage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"简历管理","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-recruiter-resumeManage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-recruiter-resumeManage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/recruiter/resumeManage',
  windowTop:44
}
},
{
path: '/pages/my/recruiter/myInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false,"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-recruiter-myInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-recruiter-myInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/recruiter/myInfo',
  windowTop:0
}
},
{
path: '/pages/index/search',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索","enablePullDownRefresh":false})
      },
      [
        createElement('pages-index-search', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-search',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/search',
  windowTop:44
}
},
{
path: '/pages/recruit/publicList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"全部公招","enablePullDownRefresh":false})
      },
      [
        createElement('pages-recruit-publicList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-recruit-publicList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recruit/publicList',
  windowTop:44
}
},
{
path: '/pages/recruit/pubilcDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"公招详情","enablePullDownRefresh":false})
      },
      [
        createElement('pages-recruit-pubilcDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-recruit-pubilcDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recruit/pubilcDetail',
  windowTop:0
}
},
{
path: '/pages/company/searchCompany',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"全部企业","enablePullDownRefresh":false})
      },
      [
        createElement('pages-company-searchCompany', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-company-searchCompany',
  isNVue:false,maxWidth:0,
  pagePath:'pages/company/searchCompany',
  windowTop:44
}
},
{
path: '/pages/recruit/tabList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"职位","enablePullDownRefresh":false})
      },
      [
        createElement('pages-recruit-tabList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-recruit-tabList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recruit/tabList',
  windowTop:44
}
},
{
path: '/pages/my/recruiter/registerCo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"企业注册","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-recruiter-registerCo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-recruiter-registerCo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/recruiter/registerCo',
  windowTop:44
}
},
{
path: '/pages/chat/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTitleText":"聊天","enablePullDownRefresh":false})
      },
      [
        createElement('pages-chat-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:5,
  name:'pages-chat-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/chat/index',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:44
}
},
{
path: '/pages/login/selectLogin',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-selectLogin', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-selectLogin',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/selectLogin',
  windowTop:44
}
},
{
path: '/pages/my/recruiter/getResume',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收到简历","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-recruiter-getResume', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-recruiter-getResume',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/recruiter/getResume',
  windowTop:44
}
},
{
path: '/pagesA/chat/chat',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"聊天","enablePullDownRefresh":false})
      },
      [
        createElement('pagesA-chat-chat', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesA-chat-chat',
  isNVue:false,maxWidth:0,
  pagePath:'pagesA/chat/chat',
  windowTop:44
}
},
{
path: '/pagesA/chat/phrase',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"自定义常用语","enablePullDownRefresh":false})
      },
      [
        createElement('pagesA-chat-phrase', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesA-chat-phrase',
  isNVue:false,maxWidth:0,
  pagePath:'pagesA/chat/phrase',
  windowTop:44
}
},
{
path: '/pagesA/smartRobot/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"Smart Robot","navigationBarBackgroundColor":"#e3eeff","enablePullDownRefresh":false})
      },
      [
        createElement('pagesA-smartRobot-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesA-smartRobot-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesA/smartRobot/index',
  windowTop:0
}
},
{
path: '/pagesB/privacyAgreement/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"隐私政策","enablePullDownRefresh":false})
      },
      [
        createElement('pagesB-privacyAgreement-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesB-privacyAgreement-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesB/privacyAgreement/index',
  windowTop:44
}
},
{
path: '/pagesB/userAgreement/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户协议","enablePullDownRefresh":false})
      },
      [
        createElement('pagesB-userAgreement-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesB-userAgreement-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesB/userAgreement/index',
  windowTop:44
}
},
{
path: '/pagesB/map/mapPage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"位置信息","enablePullDownRefresh":true})
      },
      [
        createElement('pagesB-map-mapPage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesB-map-mapPage',
  isNVue:false,maxWidth:0,
  pagePath:'pagesB/map/mapPage',
  windowTop:44
}
},
{
path: '/pagesB/recruit/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"看地图找工作","enablePullDownRefresh":true})
      },
      [
        createElement('pagesB-recruit-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesB-recruit-list',
  isNVue:false,maxWidth:0,
  pagePath:'pagesB/recruit/list',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/setAccount/changePhone',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改手机号","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-setAccount-changePhone', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-setAccount-changePhone',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/setAccount/changePhone',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/setAccount/changePassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改密码","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-setAccount-changePassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-setAccount-changePassword',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/setAccount/changePassword',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/setAccount/changeAccount',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改账号","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-setAccount-changeAccount', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-setAccount-changeAccount',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/setAccount/changeAccount',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/setAccount/mySetAccount',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账户及绑定","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-setAccount-mySetAccount', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-setAccount-mySetAccount',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/setAccount/mySetAccount',
  windowTop:44
}
},
{
path: '/pagesMy/my/contactService',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"联系客服","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-contactService', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-contactService',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/contactService',
  windowTop:44
}
},
{
path: '/pagesMy/my/myFeedback',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"意见反馈","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-myFeedback', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-myFeedback',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/myFeedback',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/mySet',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账户设置","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-mySet', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-mySet',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/mySet',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/undateVersion',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"版本更新","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-undateVersion', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-undateVersion',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/undateVersion',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/setNotice',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"通知及提醒","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-setNotice', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-setNotice',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/setNotice',
  windowTop:44
}
},
{
path: '/pagesMy/my/recruiter/myOrder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账户资产","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-recruiter-myOrder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-recruiter-myOrder',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/recruiter/myOrder',
  windowTop:44
}
},
{
path: '/pagesMy/my/recruiter/myPackage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"开通套餐","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-recruiter-myPackage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-recruiter-myPackage',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/recruiter/myPackage',
  windowTop:44
}
},
{
path: '/pagesMy/my/recruiter/companyAddress',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"企业地址","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-recruiter-companyAddress', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-recruiter-companyAddress',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/recruiter/companyAddress',
  windowTop:44
}
},
{
path: '/pagesMy/my/recruiter/companyAddressEdit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加地址","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-recruiter-companyAddressEdit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-recruiter-companyAddressEdit',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/recruiter/companyAddressEdit',
  windowTop:44
}
},
{
path: '/pagesMy/my/recruiter/downResume',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"下载简历","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-recruiter-downResume', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-recruiter-downResume',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/recruiter/downResume',
  windowTop:44
}
},
{
path: '/pagesMy/my/recruiter/myResruit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的招聘","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-recruiter-myResruit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-recruiter-myResruit',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/recruiter/myResruit',
  windowTop:44
}
},
{
path: '/pagesMy/my/recruiter/resumePublish',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"发布职位","enablePullDownRefresh":false,"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pagesMy-my-recruiter-resumePublish', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-recruiter-resumePublish',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/recruiter/resumePublish',
  windowTop:0
}
},
{
path: '/pagesMy/my/jobSeekers/myDeliver',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的投递","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-jobSeekers-myDeliver', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-jobSeekers-myDeliver',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/jobSeekers/myDeliver',
  windowTop:44
}
},
{
path: '/pagesMy/register/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账号注册","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-register-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-register-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/register/index',
  windowTop:44
}
},
{
path: '/pagesMy/my/myMembership',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的会员","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-myMembership', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-myMembership',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/myMembership',
  windowTop:44
}
},
{
path: '/pagesMy/my/attachment/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"附件简历","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-attachment-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-attachment-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/attachment/index',
  windowTop:44
}
},
{
path: '/pagesMy/my/attachment/guide',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-attachment-guide', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-attachment-guide',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/attachment/guide',
  windowTop:44
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
